import { render, staticRenderFns } from "./ExternalDamagesQuestion.vue?vue&type=template&id=69bb800a&scoped=true"
import script from "./ExternalDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./ExternalDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamagesQuestion.vue?vue&type=style&index=0&id=69bb800a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb800a",
  null
  
)

export default component.exports